import React, { Dispatch, SetStateAction } from 'react'
import { Typography } from '@material-ui/core'
import styles from './quilt.module.scss'
import quilts from './quilts'
import QuiltViewer from './QuiltViewer'
import { Scrollbars } from 'react-custom-scrollbars'
import AudioLib from 'AudioLib/AudioLib'
import quiltType from './quiltType'
import Stage from 'components/Designer/Stage'
import Quilt from 'designer/geoHandlers/Material/quilt'

const QuiltBrowser = () => {
  const stage = Stage.getInstance()
  return (
    <Scrollbars
      style={{
        width: '100%',
        height: 'calc(100vh - 40vh)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div className={styles.quiltBrowser}>
        <div className={styles.quiltCard}>
          <div
            className={styles.sQuiltPreview}
            onClick={() => {
              {
                Quilt.setQuilt(null)
                /* stage.quilt = undefined */
              }
              AudioLib.select()
            }}
          />
          <Typography>None</Typography>
        </div>
        {quilts.map(q => {
          return (
            <div
              className={styles.quiltCard}
              key={q.path}
              title={`${q.scale[0]}`}
            >
              <QuiltViewer
                path={`/quilts/${q.path}`}
                className={styles.sQuiltPreview}
                color="transparent"
                stitchColor="white"
                onClick={() => {
                  AudioLib.select()
                  Quilt.setQuilt({
                    ...q,
                    path: `/quilts/${q.path}`,
                  })
                  {
                    /* stage.quilt = { ...q, path: `/quilts/${q.path}` } */
                  }
                }}
              />
              <Typography>{q.name}</Typography>
            </div>
          )
        })}
      </div>
    </Scrollbars>
  )
}
export default QuiltBrowser
